export const DEV_TOOLBAR_CONSTANTS = {
  labels: {
    toggleButton: 'Dev',
    toggleAriaLabel: 'Toggle dev toolbar',
    isBrowser: 'isBrowser',
    simulateHydration: 'Simulate hydration'
  },
  timing: {
    hydrationDelayMs: 1000
  }
} as const;
